import React from 'react';

import { Button } from '@trqk/components';
import { locale } from '@trqk/utils';

/**
 * A RenderContent component for a Toast which warns the user about the consequences of deleting
 * audio files.
 * @param props {@link ToastRenderContentProps}
 */
export const DeleteAudioWarning = ({
    input,
    remove,
}: ToastRenderContentProps<{ selectedFiles: number }>): JSX.Element => {
    const selectedFiles = input?.selectedFiles ?? 0;
    const dictionary =
        selectedFiles === 1
            ? locale.enUS.MANAGE_DETECTIONS.TOASTS.DELETE_AUDIO_WARNING
                  .DESCRIPTION.SINGULAR
            : locale.enUS.MANAGE_DETECTIONS.TOASTS.DELETE_AUDIO_WARNING
                  .DESCRIPTION.PLURAL;

    return (
        <div style={{ width: 350 }} className="px-2 text-sm">
            <div className="font-bold text-highlight-orange tracking-wider">
                {
                    locale.enUS.MANAGE_DETECTIONS.TOASTS.DELETE_AUDIO_WARNING
                        .TITLE
                }
            </div>
            <div className="mt-4 mb-8">
                <strong>
                    {`${locale.enUS.MANAGE_DETECTIONS.TOASTS.DELETE_AUDIO_WARNING.DESCRIPTION.YOU_ARE_ABOUT_TO_DELETE} ${selectedFiles} ${dictionary.AUDIO}.`}
                </strong>
                <p className="mt-4 mb-2">
                    {
                        locale.enUS.MANAGE_DETECTIONS.TOASTS
                            .DELETE_AUDIO_WARNING.DESCRIPTION.IF_YOU_DO_THIS
                    }
                </p>
                <ul className="list-disc">
                    <li>{dictionary.AUDIO_WILL_BE_DELETED}</li>
                    <li>{dictionary.DETECTIONS_STILL_EXIST}</li>
                </ul>
            </div>
            <div className="flex justify-end">
                <Button
                    addClasses="mr-4"
                    color="danger-secondary-light-bg"
                    autoWidth={true}
                    handleClick={(): void => {
                        remove({
                            canceled: true,
                            success: false,
                        });
                    }}
                >
                    <div className="mx-4">
                        {
                            locale.enUS.MANAGE_DETECTIONS.TOASTS
                                .DELETE_AUDIO_WARNING.BUTTONS.CANCEL
                        }
                    </div>
                </Button>
                <Button
                    color="danger-primary-light-bg"
                    autoWidth={true}
                    handleClick={(): void => {
                        remove({
                            canceled: false,
                            success: true,
                        });
                    }}
                >
                    <div className="mx-4">
                        {
                            locale.enUS.MANAGE_DETECTIONS.TOASTS
                                .DELETE_AUDIO_WARNING.BUTTONS.CONFIRM
                        }
                    </div>
                </Button>
            </div>
        </div>
    );
};
